// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  height: 100%;
  margin: 0.5em;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.dashboard-container .custom-bar-chat {
  height: 15em;
}
.dashboard-container .full-border {
  border: 2px solid black;
  background-color: white !important;
}
.dashboard-container .token-details {
  display: flex;
  flex-direction: column;
  height: 5em;
}

.row {
  width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/Dashboard.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AACJ;AACI;EACI,YAAA;AACR;AAEI;EACI,uBAAA;EACA,kCAAA;AAAR;AAGI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AADR;;AAKA;EACI,sBAAA;AAFJ","sourcesContent":[".dashboard-container {\n    height: 100%;\n    margin: 0.5em;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n\n    .custom-bar-chat {\n        height: 15em;\n    }\n\n    .full-border {\n        border: 2px solid black;\n        background-color: white !important;\n    }\n\n    .token-details {\n        display: flex;\n        flex-direction: column;\n        height: 5em;\n    }\n}\n\n.row {\n    width: 100% !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
